import React, {useRef, useContext} from 'react';
import { NavLink } from 'react-router-dom';

import './navigation.styles.css';

import {AuthContext}  from '../../utils/context/auth-context';

const Navigation = () => {

    const auth = useContext(AuthContext);

    const checkboxRef = useRef();

    return (
    <div className="navigation">
            <input ref={checkboxRef} type="checkbox" className="navigation__checkbox" id="navi-toggle"></input>

            <label htmlFor="navi-toggle" className="navigation__button">
                <span className="navigation__icon">&nbsp;</span>
            </label>

            <div className="navigation__background">&nbsp;</div>

            <nav className="navigation__nav">
                <ul onClick={() => {checkboxRef.current.checked= false}} className="navigation__list">
                    <li className="navigation__item"><NavLink to='/' exact className="navigation__link">Početna</NavLink></li>
                    <li className="navigation__item"><NavLink to='/aboutus' exact className="navigation__link">O Nama</NavLink></li>                    
                    <li className="navigation__item"><NavLink to='/izvestaji' className="navigation__link">Izveštaji</NavLink></li>
                    <li className="navigation__item"><NavLink to='/godisnjiplan' className="navigation__link">Godišnji Plan</NavLink></li>
                    <li className="navigation__item"><NavLink to='/viaferrata' className="navigation__link">Via Ferrata Tim</NavLink></li>
                    {!auth.isLoggedIn && <li className="navigation__item"><NavLink to='/nastim' className="navigation__link">Naš Tim</NavLink></li>}
                    {!auth.isLoggedIn &&  <li className="navigation__item"><NavLink to='/login' className="navigation__link">Login</NavLink></li>}
                    {auth.isLoggedIn &&  <li className="navigation__item"><NavLink to='/izvestaj/new' className="navigation__link">Kreiraj Izveštaj</NavLink></li> } 
                    {auth.isLoggedIn && <li className="navigation__item"><NavLink to='/najava/new' className="navigation__link">Kreiraj Najavu</NavLink></li> }
                    {auth.isLoggedIn &&  <li className="navigation__item"><a onClick={auth.logout} className="navigation__link navigation__link-extra">Logout</a></li>}
                   
                   
                </ul>
            </nav>
    </div>  
    )
};



export default Navigation;